import { createSelector } from 'reselect';

const getUser = (state) => state.user;

export const currentUserSelector = createSelector(
  getUser,
  (user) => user,
);

export const companyIdSelector = createSelector(
  currentUserSelector,
  (user) => user.company_id,
);

export const selectUserLocation = (state) => state.userLocation;
